/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentRestrictionSetPasswordParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('set')],
]);
export class AssignmentRestrictionSetPassword extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentRestrictionSetPasswordParser.decode(input).map(res => new AssignmentRestrictionSetPassword(res));
    }
    static unsafeDecode(input) {
        return AssignmentRestrictionSetPassword.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentRestrictionSetPasswordParser.encode(data);
    }
    static schema() {
        return AssignmentRestrictionSetPasswordParser.schema();
    }
}
